var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Interface',[_c('div',{staticClass:"flex-direction-column flex-grow-1 d-flex align-center justify-center"},[_c('div',{staticClass:"vp-warning text-center"},[_c('v-icon',{attrs:{"color":"grey","x-large":""}},[_vm._v("mdi-alert-box")]),_c('h1',[_vm._v("Page Not Found")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }